import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Mail } from 'lucide-react';
import NewsletterBlock from './NewsletterBlock';
import { Dialog, DialogContent, DialogTitle } from './ui/dialog';

export const NewsletterSchwebeButton = ({ activeArea }) => {
  const { t } = useTranslation();
  const [offen, setOffen] = useState(false);
  const label = t('newsletter.cta_float', 'Newsletter abonnieren');
  return (
    <>
      <button type="button" onClick={() => setOffen(true)} aria-label={label} title={label}
        className="fixed right-4 sm:right-6 bottom-24 sm:bottom-auto sm:top-[170px] lg:top-[200px] z-40 inline-flex items-center justify-center gap-2 w-11 h-11 sm:w-auto sm:h-auto sm:pl-3.5 sm:pr-4 sm:py-2.5 rounded-full bg-[#b8893d] text-white text-xs tracking-[0.18em] uppercase font-medium shadow-lg shadow-[#b8893d]/30 hover:bg-[#1B3A5C] hover:-translate-y-0.5 transition-[background-color,transform] duration-200 animate-in fade-in slide-in-from-right-4"
        data-testid="newsletter-schwebe-button">
        <Mail className="w-4 h-4" /> <span className="hidden sm:inline">{label}</span>
      </button>
      <Dialog open={offen} onOpenChange={setOffen}>
        <DialogContent className="max-w-3xl p-0 overflow-y-auto max-h-[92vh] bg-transparent border-0 shadow-none [&>button]:!text-white [&>button]:!bg-transparent [&>button]:opacity-90 [&>button]:z-10" data-testid="newsletter-dialog">
          <DialogTitle className="sr-only">{label}</DialogTitle>
          <NewsletterBlock activeArea={activeArea} />
        </DialogContent>
      </Dialog>
    </>
  );
};
